import $ from 'jquery';
import { loadSelectTags } from '~src/sidebar/index';

export const displayImageManagerMultiTag = () => {
  const selectTagsHtml = `
  <div id="tag-select">
    <select id="tagImageSelectUpload" multiple="multiple"> </select>
  </div>
  `;
  $('#selectTag-container-multi-tag').html(selectTagsHtml);
  loadSelectTags();
};
